export const getMembersOrigin = (): string => (
    process.env.REACT_APP_MEMBERS_ORIGIN || 'https://members.speak2family.com'
);

export const getNeighborsOrigin = (): string => (
    process.env.REACT_APP_NEIGHBORS_ORIGIN || 'https://neighbors.speak2family.com'
);
